import { ArrowRight, Play } from 'lucide-react'

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section id="home" className="pt-16 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto container-padding section-spacing">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Transform Your Business with{' '}
              <span className="text-primary">Digital Marketing Excellence</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Drive growth, increase revenue, and dominate your market with our 
              data-driven digital marketing strategies. Get measurable results that 
              matter to your bottom line.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={scrollToContact}
                className="btn-primary flex items-center justify-center gap-2 text-lg px-8 py-4"
              >
                Get Your Free Strategy Session
                <ArrowRight size={20} />
              </button>
              
              <button className="flex items-center justify-center gap-2 text-primary font-semibold hover:text-primary-600 transition-colors duration-200 px-8 py-4">
                <Play size={20} />
                Watch Success Stories
              </button>
            </div>

            {/* Stats */}
            <div className="mt-12 grid grid-cols-3 gap-8 text-center lg:text-left">
              <div>
                <div className="text-3xl font-bold text-primary">200+</div>
                <div className="text-sm text-gray-600">Happy Clients</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">500%</div>
                <div className="text-sm text-gray-600">Avg ROI Increase</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary">24/7</div>
                <div className="text-sm text-gray-600">Expert Support</div>
              </div>
            </div>
          </div>

          {/* Right Column - Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-primary-100 to-secondary-100 rounded-2xl p-8 lg:p-12">
              {/* Placeholder for hero image/illustration */}
              <div className="aspect-square bg-white rounded-xl shadow-lg flex items-center justify-center">
                <div className="text-center">
                  <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center">
                      <ArrowRight size={24} />
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Digital Growth
                  </h3>
                  <p className="text-gray-600">
                    Accelerate your business success
                  </p>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-secondary text-white px-4 py-2 rounded-lg shadow-lg">
                <div className="text-sm font-semibold">+300% Traffic</div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-primary text-white px-4 py-2 rounded-lg shadow-lg">
                <div className="text-sm font-semibold">450% ROI</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero